module.exports = __webpack_public_path__ + "static/media/Upper-page.e40dd6ce.svg";